import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environmentPingId ,pingIdToken } from "src/environments/environment";
import { ABappointment } from "./api-interfaces/IBAppointment.interface";
import { Message } from "./api-interfaces/message.interface";
import { IBAppointmentGET } from "./api-interfaces/IBAppointmentGET.interface";
import { timeSlotWorkshops } from "./api-interfaces/IBWorkshopsTimeSlots.interface";
import { HelperService } from "../helperService";

@Injectable({
    providedIn: 'root'
})

export class IncadeaBookingService{
    ApiURL: string = "";

    constructor(private http: HttpClient,public helperService: HelperService) {
        this.ApiURL =  environmentPingId.PingIdvehicleDataUrl + 'external-appointment/';
        }
        public getIBAppointment(SiteUse:string,plateNumber: string,pageNumber:string,pageSize:string, identification?: string){
            const headers = new HttpHeaders()
                    .set('Authorization', `Bearer ${this.helperService.TokenBooking}`)
                    .set('x-apikey', pingIdToken.clientId );
            const requestOptions = {
              headers: headers,
            };
              
           const body: any = {
                        Flag: Number(SiteUse),
                        Plate: plateNumber,
                        Id:identification ? identification : "0",
                        NumberPage: Number(pageNumber),
                        PageSize: Number(pageSize)
                        };
               
                return this.http.post<any >(this.ApiURL+"info",body,requestOptions) 

        
        }

           public getTimeSlotsScheduler(companyId:string,locationId:string, departmentCode:string){
             const headers = new HttpHeaders()
                    .set('Authorization', `Bearer ${this.helperService.TokenBooking}`)
                    .set('x-apikey', pingIdToken.clientId );
            const requestOptions = {
              headers: headers,
            };
              
             const body: any = {
                CompanyId: companyId,
                LocationId: locationId,
                Department: departmentCode
              }
               
                return this.http.post<any >(this.ApiURL+"info",body,requestOptions) 
        }



        
        public createIBAppointment(appointment:ABappointment){
             const headers = new HttpHeaders()
                    .set('Authorization', `Bearer ${this.helperService.TokenBooking}`)
                    .set('x-apikey', pingIdToken.clientId );
            const requestOptions = {
              headers: headers,
            };
            return this.http.post<Message>(`${this.ApiURL}create`,appointment,requestOptions)
        }

        public cancelAppointment(appointmentId){
            const headers = new HttpHeaders()
                    .set('Authorization', `Bearer ${this.helperService.TokenBooking}`)
                    .set('x-apikey', pingIdToken.clientId );
            const requestOptions = {
                headers: headers,
              };
              const body: any ={AppointmentId: appointmentId, 
                }
            return this.http.post<any>(`${this.ApiURL}delete`,body,requestOptions)
        }
     

        public UpdateAppointmentStatus(appointmentId:string,statusId:number){
          const headers = new HttpHeaders()
                    .set('Authorization', `Bearer ${this.helperService.TokenBooking}`)
                    .set('x-apikey', pingIdToken.clientId );
            const requestOptions = {
                headers: headers,
              };
              {
            const body: any ={AppointmentId: appointmentId,
                  StatusId: statusId
                }
             return this.http.post<Message>(`${this.ApiURL}update`,body,requestOptions) 
        }
}
 public upDateIBAppointment(appointment:ABappointment,appointmentId:string){
            const headers = new HttpHeaders()
                    .set('Authorization', `Bearer ${this.helperService.TokenBooking}`)
                    .set('x-apikey', pingIdToken.clientId );
            const requestOptions = {
                headers: headers,
              };
              appointment.UpdateAppointmentId = appointmentId
            return this.http.post<Message>(`${this.ApiURL}update`,appointment,requestOptions)
        }
}
